"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = exports.TextArea = void 0;
const createTextField_1 = require("./createTextField");
exports.TextArea = createTextField_1.createTextInput('textarea', { rows: 5 });
exports.TextField = createTextField_1.createTextInput('input');
//# sourceMappingURL=TextField.js.map